function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgExpertSecondOpinion = function SvgExpertSecondOpinion(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 20"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    fillRule: "evenodd",
    d: "M14.667 15.833h2.916v.834h-3.75v-3.75h.834zM6.692 4.527a6.667 6.667 0 0 0 5.8 11.834l.25.795A7.5 7.5 0 0 1 6.216 3.843z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    fillRule: "evenodd",
    d: "M14.308 15.472A6.666 6.666 0 0 0 8.507 3.638l-.25-.795a7.5 7.5 0 0 1 6.527 13.313zM6.333 4.167H3.417v-.834h3.75v3.75h-.834z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement(Path, {
    stroke: props.accentFillLine,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.593,
    d: "M8.967 7.415h2.767M9.56 11.763h1.581m-.79.79v-1.58m1.185-1.513a2.77 2.77 0 0 1 1.582 2.5v.791a.79.79 0 0 1-.791.79H8.374a.79.79 0 0 1-.79-.79v-.79c0-1.104.646-2.057 1.58-2.501m1.187.326c-.765 0-1.384-.62-1.384-1.383v-1.78a.79.79 0 0 1 .79-.79h1.187a.79.79 0 0 1 .79.79v1.78c0 .764-.62 1.383-1.383 1.383"
  }));
};
export default SvgExpertSecondOpinion;